/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';

/**
 * 
 * @export
 * @interface AdminUpdateProductsStatus
 */
export interface AdminUpdateProductsStatus {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateProductsStatus
     */
    productIds: Array<string>;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminUpdateProductsStatus
     */
    status: AdminProductStatus;
}



export function AdminUpdateProductsStatusFromJSON(json: any): AdminUpdateProductsStatus {
    return AdminUpdateProductsStatusFromJSONTyped(json, false);
}

export function AdminUpdateProductsStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateProductsStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productIds': json['productIds'],
        'status': AdminProductStatusFromJSON(json['status']),
    };
}

export function AdminUpdateProductsStatusToJSON(value?: AdminUpdateProductsStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productIds': value.productIds,
        'status': AdminProductStatusToJSON(value.status),
    };
}

